const ROOT = 'User/createUser';

export const FETCH_CREATEUSER_REQUEST = `${ROOT}/FETCH_CREATEUSER_REQUEST`;
export const FETCH_CREATEUSER_SUCCESS = `${ROOT}/FETCH_CREATEUSER_SUCCESS`;
export const FETCH_CREATEUSER_FAILURE = `${ROOT}/FETCH_CREATEUSER_FAILURE`;
export const FETCH_REFRESHTOKEN_REQUEST = `${ROOT}/FETCH_REFRESHTOKEN_REQUEST`;
